<template>
  <button class="rounded-sm bg-white shadow p-6">
    <slot />
  </button>
</template>
